import { useMutation } from '@apollo/client';
import { mutationFeedback } from '../../queries';

const useMutationFeedback = () => {
  const [actionFeedback] = useMutation(mutationFeedback);

  return { actionFeedback };
};

export default useMutationFeedback;
export { useMutationFeedback };
